import { AlertTriangle } from 'lucide-react'

export function RepeatWarnings(): JSX.Element {
  return (
    <div className="rounded-xl border border-red-200 bg-red-50/40 p-4">
      <div className="mb-2 flex items-center gap-2">
        <AlertTriangle className="h-5 w-5 text-red-500" />
        <h3 className="text-base font-semibold text-gray-900">Repeat Warnings</h3>
      </div>
      <p className="text-sm text-gray-600">
        Repeat-warning detection will appear here once backend analysis is available.
      </p>
    </div>
  )
}
